import { defineMessages } from 'react-intl';

export const dashboardMessages = defineMessages({
  recategorisationSuccess: {
    id: 'recategorization.success_notification',
    defaultMessage: 'The category has been successfully modified. The analysis has been updated.',
    description: 'Text of the category modification success notification',
  },
  recategorisationError: {
    id: 'recategorization.error_notification',
    defaultMessage: 'The category could not be modified.',
    description: 'Text of the category modification error notification',
  },
});
